<!--
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2021-11-08 16:57:52
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-14 20:00:47
 * @FilePath: /jy-dashboard-web/src/components/companyProfile/loadingBar.vue
 * @Description: 描述
-->
<template>
  <div class="loading-bar" ref="loading-bar">
    <el-row class="type" v-for="(item, index) in formData" :key="index">
      <el-col :span="24">
        <div class="name">No.{{ index + 1 + " " + item.name }}</div>
      </el-col>
      <el-col :span="18">
        <div class="rate">
          <div class="temp">
            <div class="rated" :style="{ '--rate': item.rate }"></div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="num" v-if="item.value === 0">
          {{ item.value }}
        </div>
        <ICountUp
          class="num"
          v-else
          :endVal="Number(item.value)"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'loading-bar',
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    formData () {
      let { data } = this
      // 最大值
      const maxValue = Math.max(...data.map((item) => { return item.value }))
      data = data.sort((pre, cur) => {
        // 排序
        return cur.value - pre.value
      }).map((item) => {
        // 算出每项与最大值的比值
        item.rate = item.value / maxValue
        return item
      })
      return data
    }
  }
}
</script>

<style lang="scss">
.loading-bar {
  display: flex;
  flex-direction: column;
  height: 100%;
  // overflow-y: auto;
  .type {
    position: relative;
    width: 100%;
    height: 33px;
    line-height: 33px;
    // margin-top: 6px;
    margin-bottom: 23px;
    .name {
      font-size: 16px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #c9d9db;
      height: 16px;
      line-height: 16px;
      margin-bottom: 9px;
    }
    .rate {
      width: 100%;
      height: 5px;
      margin: 4px 0;
      background: rgba(165, 212, 245, 0.1);
      border-radius: 2px;
      @keyframes loading {
        0% {
          width: 0;
        }
        25% {
          width: 100%;
        }
        100% {
          width: 100%;
        }
      }
      .temp {
        animation: loading 16s infinite;
        .rated {
          width: calc(var(--rate) * 100%);
          height: 4px;
          background: linear-gradient(90deg, #36b8db 0%, #07fab2 100%);
          border-radius: 2px;
          position: relative;
          &::after {
            content: "";
            position: absolute;
            right: 0;
            top: -1px;
            width: 2px;
            height: 6px;
            background: #ffffff;
            border-radius: 1px;
          }
        }
      }
    }
    .num {
      display: block;
      text-align: right;
      font-size: 20px;
      font-family: Montserrat;
      font-weight: 400;
      color: #6df9ff;
      height: 16px;
      line-height: 16px;
      &::after {
        content: "人次";
        font-size: 16px;
        font-family: Montserrat;
        font-weight: 400;
        color: #ffffff;
        display: inline-block;
      }
    }
  }
}
</style>
